
export default function Footer() {
  const services = [
    'Construction Project Management',
    'HVAC Installation & Design',
    'Specialty Facility Construction',
    'Clean Room Development',
    'Industrial Facility Projects',
    'Energy Efficiency Consulting'
  ];

  const industries = [
    'Healthcare Facilities',
    'Manufacturing Plants',
    'Data Centers',
    'Pharmaceutical',
    'Research Laboratories',
    'Food Processing'
  ];

  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <img 
              src="https://static.readdy.ai/image/51a88c584cf88c9ad8e9758347b3e63d/9cb24b4a8cea094c3122fabfd7fc0522.png" 
              alt="SGBS - Strategic Global Business Solutions" 
              className="h-12 mb-6"
            />
            <p className="text-gray-300 mb-6 leading-relaxed">
              Delivering precision-engineered solutions for construction project management, HVAC systems, and specialty facility projects with unmatched technical expertise.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Industries</h4>
            <ul className="space-y-3">
              {industries.map((industry, index) => (
                <li key={index}>
                  <a href="#" className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer">
                    {industry}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-center">
                <i className="ri-map-pin-line text-orange-500 mr-3"></i>
                <span className="text-gray-300">4920 Evergreen Way #1126<br />Everett WA 98203</span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-orange-500 mr-3"></i>
                <span className="text-gray-300">1 (425) 699-1038</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-orange-500 mr-3"></i>
                <span className="text-gray-300">mysgbs@outlook.com</span>
              </div>
            </div>

            <div className="mt-8">
              <h5 className="font-semibold mb-3">Business Hours</h5>
              <div className="text-gray-300 text-sm space-y-1">
                <div>Monday - Friday: 7:00 AM - 6:00 PM</div>
                <div>Saturday: 8:00 AM - 4:00 PM</div>
                <div>Sunday: Emergency Only</div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              © 2024 SGBS - Strategic Global Business Solutions. All rights reserved. Licensed &amp; Insured.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-300 hover:text-orange-500 text-sm transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-300 hover:text-orange-500 text-sm transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-300 hover:text-orange-500 text-sm transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
